import React, { Component } from 'react';
import {withRouter} from 'react-router-dom';
import withStyles from 'react-jss'
import {withContext} from '../../../custom/StateProvider';
/*import Statement from "./statement";
import InvestorWithdrawals from "./withdrawals";
import InvestorDeposits from "./deposits";
import WalletJournalButton from "./walletJournalButton";*/
import IntroEmail from "./comms_introemail";
import ForgotPassword from "./comms_forgot_password";
import ResetPassword from "./comms_reset_password";
import AccountMaint from "./comms_account_maint";
import {connect} from "react-redux";
import Paper from '@material-ui/core/Paper';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import {Button} from "@material-ui/core";
import {BROKER_SHORT} from "../../../../config";

const styles = theme => ({
    sectionHeader:{
        position:'absolute',
        top:0,
        left:0,
        backgroundColor:'white',
        width: '100%',
        zIndex: 100,
        paddingTop: '5px',
    },
    tabs:{
        display:'inline-block',
        width:'100%',
        borderBottom:'2px solid #6a94ff',
        marginLeft:0,
        paddingLeft:0,

        '& li':{
            display:'inline-block',

            '& button':{
                margin:'1px',
                padding:'6px 12px',
                backgroundColor:'#383c42',
                color:'white'
            },
            '& button:hover':{
                backgroundColor:'#6a94ff',
            },
            '& button.active':{
                backgroundColor:'#6a94ff',
            }
        }
    },
    flex: {
        flex: 1,
    },
    full:{
        height: 'calc(100% - 15px)'
    }
});

class Comms extends Component {
    state={
        activeTab:'usd'
    };

    changeTab = (e) => {
        this.setState({
            activeTab:e.target.id
        })
    }

    introductionEmail = (e) => {
        this.setState({
            type:'introduction_email'
        })
    }

    passwordForgot = (e) => {
        this.setState({
            type:'forgot_password'
        })
    }

    passwordReset = (e) => {
        this.setState({
            type:'password_reset'
        })
    }

    accountMaint = (e) => {
        this.setState({
            type:'account_maint'
        })
    }

    render() {
        const {classes} = this.props;

        return (
            <div className={'flex-col flex h-full here'}>

                <div className={'flex ' + classes.full}>
                    <div style={{width:'25%'}}>
                        <Paper style={{position: 'relative', margin: 5}}>
                            <AppBar position="static" elevation={0} color={"default"}>
                                <Toolbar>
                                    <Typography variant="title" color="inherit" className={classes.flex}>
                                        Communications
                                    </Typography>
                                </Toolbar>
                            </AppBar>

                            <div style={{overflow: 'auto', height: '100%', padding: 5}}>
                                <Button onClick={this.introductionEmail}>Introduction Email</Button><br />
                                <Button onClick={this.passwordForgot}>Forgot Password</Button><br />
                                <Button onClick={this.passwordReset}>Password Reset</Button><br />
                                {(BROKER_SHORT === 'PYGG') && <Button onClick={this.accountMaint}>Account Maintenance</Button> }
                            </div>
                        </Paper>
                    </div>

                    <div className={'flex-1'}>
                        {(this.state.type === 'introduction_email') &&
                            <IntroEmail investor={this.props.investor}/>
                        }

                        {(this.state.type === 'forgot_password') &&
                            <ForgotPassword investor={this.props.investor}/>
                        }

                        {(this.state.type === 'password_reset') &&
                            <ResetPassword investor={this.props.investor}/>
                        }

                        {(this.state.type === 'account_maint') &&
                        <AccountMaint investor={this.props.investor}/>
                        }
                    </div>
                </div>

            </div>
        )
    }
}

function mapStateToProps({ fuse, auth }) {
    return {
        user: auth.user
    }
}

export default withContext(withStyles(styles,{withTheme:true})(withRouter(connect(mapStateToProps)(Comms))));
